import ClothItem from './ClothItem';

export default class ClothesList extends Phaser.Group {
  constructor(game) {
    super(game);

    this.data = this.game.controller.gameData.clothes;

    // create rail
    this.rail = this.game.make.image(0, 0, 'ui_dress_up', 'rail');
    this.rail.anchor.set(0.5, 0);
    this.rail.scale.x = 2;
    this.addChild(this.rail);

    //
    this.createItems();
  }

  createItems() {
    this.clothes = [];
    let ind = 0;
    for (let i = 0; i < this.data.length; i++) {
      const clothData = this.data[i];
      if (clothData.wearable) {
        const cloth = new ClothItem(this.game, clothData, this);
        cloth.y = -10;
        cloth.x = ind * 130;
        this.clothes[clothData.id] = cloth;
        this.addChild(cloth);
        ind++;
      }
    }

    // position them properly
    const len = this.clothes.length;
    const x0 = -(len - 1) * 0.5 * 130;
    for (let i = 0; i < len; i++) {
      const cloth = this.clothes[i];
      cloth.x = x0 + i * 130;
    }
  }

  init(characterClothId, characterId) {
    this.reset();
    if (characterClothId > -1) {
      this.clothes[characterClothId].showCharacterCloth(characterId);
    }
  }

  reset() {
    const len = this.clothes.length;
    for (let i = 0; i < len; i++) {
      this.clothes[i].resetOutfit();
    }
  }

  pulseItems() {
    this.pulseEnabled = true;
    this.pulseInd = 0;
    this.clothes[this.pulseInd].pulse();
    this.game.time.events.add(600, this.pulseNextItem, this);
  }

  pulseNextItem() {
    if (this.pulseEnabled) {
      this.pulseInd = (this.pulseInd + 1) % this.clothes.length;
      this.clothes[this.pulseInd].pulse();
      this.game.time.events.add(600, this.pulseNextItem, this);
    }
  }

  stopPulseItems() {
    this.pulseEnabled = false;
    this.clothes[this.pulseInd].stopPulse();
  }
}
